import {
  NavItem,
  PlatformKeys,
  SocialKeys,
  Socials,
} from "@kelp-dao/kernel-design-system";
import { VaultIcon } from "@phosphor-icons/react";

import { trackEvent } from "utils";
import { FAVICONS } from "@constants/images";

export const getGainAppNavItems = (): NavItem[] => {
  return [
    {
      label: "Products",
      skipLabelInMobile: true,
      skipInDesktop: true,
      submenu: [
        {
          label: "Kelp",
          description: "Restaked ETH. Routed across 10+ L2s.",
          skipDescriptionInMobile: true,
          href: `https://kerneldao.com/kelp`,
          external: true,
          icon: (
            <img
              src={FAVICONS.Kelp.src}
              alt="Kelp"
              className="w-4 h-4 lg:w-6 lg:h-6"
            />
          ),
          sendEvent: () => {
            trackEvent("lp_product_selected", {
              event_type: "button_click",
              event_category: "Landing",
              event_label: "Kelp",
              location: "header",
            });
          },
        },
        // {
        //   label: "Gain",
        //   description:
        //     "No lockups. No thresholds. Just vaults that don't sleep.",
        //   skipDescriptionInMobile: true,
        //   href: `https://kerneldao.com/gain`,
        //   external: true,
        //   icon: (
        //     <img
        //       src={FAVICONS.Gain.src}
        //       alt="Gain"
        //       className="w-4 h-4 lg:w-6 lg:h-6"
        //     />
        //   ),
        //   sendEvent: () => {
        //     trackEvent("lp_product_selected", {
        //       event_type: "button_click",
        //       event_category: "Landing",
        //       event_label: "Gain",
        //       location: "header",
        //     });
        //   },
        // },
        {
          label: "Kernel",
          description: "Restake BNB, BTC & more. Secure 25+ protocols.",
          skipDescriptionInMobile: true,
          href: `https://kerneldao.com/kernel`,
          external: true,
          icon: (
            <img
              src={FAVICONS.Kernel.src}
              alt="Kernel"
              className="w-4 h-4 lg:w-6 lg:h-6"
            />
          ),
          sendEvent: () => {
            trackEvent("lp_product_selected", {
              event_type: "button_click",
              event_category: "Landing",
              event_label: "Kernel",
              location: "header",
            });
          },
        },
      ],
    },
    {
      label: "All Vaults",
      description:
        "Deposit to vaults to earn the highest yield on your assets.",
      skipInDesktop: true,
      href: "https://gain.kerneldao.com/vaults/",
      icon: (
        <VaultIcon
          weight="fill"
          color="black"
          className="w-4 h-4 lg:w-6 lg:h-6"
        />
      ),
      submenuFooter: (
        <Socials
          platformIconWidth={12}
          platformIconHeight={12}
          size={24}
          socials={[
            {
              key: SocialKeys.TWITTER,
              link: "https://x.com/kernel_dao",
              platformKey: PlatformKeys.KERNEL,
              sendEvent: () => {
                trackEvent("lp_social_click", {
                  event_type: "button_click",
                  event_category: "Landing",
                  platform: "x",
                  location: "header",
                  destination_url: "https://x.com/kernel_dao",
                });
              },
            },
            {
              key: SocialKeys.TWITTER,
              link: "https://x.com/KelpDAO",
              platformKey: PlatformKeys.KELP,
              sendEvent: () => {
                trackEvent("lp_social_click", {
                  event_type: "button_click",
                  event_category: "Landing",
                  platform: "x",
                  location: "header",
                  destination_url: "https://x.com/KelpDAO",
                });
              },
            },
            {
              key: SocialKeys.DISCORD,
              link: "https://discord.gg/khSpqCFvGq",
              sendEvent: () => {
                trackEvent("lp_social_click", {
                  event_type: "button_click",
                  event_category: "Landing",
                  platform: "discord",
                  location: "header",
                  destination_url: "https://discord.gg/khSpqCFvGq",
                });
              },
            },
            {
              key: SocialKeys.TELEGRAM,
              link: "https://t.me/KelpDAOxyz/",
              sendEvent: () => {
                trackEvent("lp_social_click", {
                  event_type: "button_click",
                  event_category: "Landing",
                  platform: "telegram",
                  location: "header",
                  destination_url: "https://t.me/KelpDAOxyz/",
                });
              },
            },
          ]}
        />
      ),
    },
  ];
};
